import { GETREQUESTOPTIONS, instance } from '../apiService';

export type OnboardingWizardStatus =
    | 'not_started'
    | 'started'
    | 'dismissed'
    | 'completed';

export type OnboardingWizardAction =
    | 'auto_opened'
    | 'opened'
    | 'dismissed'
    | 'completed'
    | 'step_changed';

export interface OnboardingWizardState {
    onboardingWizardStatus: OnboardingWizardStatus;
    onboardingWizardCurrentStep: number;
    onboardingWizardStartedAt: string | null;
    onboardingWizardDismissedAt: string | null;
    onboardingWizardCompletedAt: string | null;
    onboardingWizardLastOpenedAt: string | null;
    onboardingWizardFirstShownAt: string | null;
    isNewUserForOnboarding: boolean;
}

export interface UpdateOnboardingWizardInput {
    action: OnboardingWizardAction;
    currentStep?: number;
}

export const getOnboardingWizardState =
    async (): Promise<OnboardingWizardState> => {
        const res = await instance.get(
            '/api/user/onboarding-wizard',
            GETREQUESTOPTIONS()
        );
        return res.data;
    };

export const updateOnboardingWizardState = async (
    input: UpdateOnboardingWizardInput
): Promise<OnboardingWizardState> => {
    const res = await instance.post(
        '/api/user/onboarding-wizard',
        input,
        GETREQUESTOPTIONS()
    );
    return res.data;
};
